import { httpClient } from '@/core/services/http'
import { unstable_cache } from 'next/cache'
import { createGetCitySlugsUseCase } from '../use-cases/get-cities.usecase'
import { createGetCityDetailsUseCase } from '../use-cases/get-city-details.usecase'

export const getCityDetails = unstable_cache(
  createGetCityDetailsUseCase({
    httpClient,
  }),
  ['city-details'],
  { revalidate: 3600 },
)

export const getCitySlugs = unstable_cache(
  createGetCitySlugsUseCase({
    httpClient,
  }),
  ['city-slugs'],
  { revalidate: 3600 },
)
